import {
  BottomSheetBody,
  BottomSheetFooter,
  BottomSheetHeader,
  BottomSheetHeaderTitle,
  EmptyState,
} from "@opensea/ui-kit"
import { useMountEffect } from "@opensea/ui-kit/hooks"
import { useState } from "react"
import type { FallbackProps } from "react-error-boundary"
import { useTranslations } from "use-intl"
import { Button } from "../../components/Button"
import { useTrackError } from "../../providers/TrackErrorProvider"
import { FlowState } from "../../stores/flowStore"

type Props = FallbackProps

export function BottomSheetErrorBoundaryFallback({
  error,
  resetErrorBoundary,
}: Props) {
  const t = useTranslations("wallet.BottomSheetError")
  const trackError = useTrackError()
  const [errorId, setErrorId] = useState<string | undefined>()

  useMountEffect(() => {
    const { flow } = FlowState
    const id = trackError(error, {
      extra: {
        flow,
      },
      tags: {
        ...(flow?.type ? { flow: flow.type } : {}),
      },
    })
    setErrorId(id)
  })

  return (
    <>
      <BottomSheetHeader>
        <BottomSheetHeaderTitle hidden={true}>
          {t("title")}
        </BottomSheetHeaderTitle>
      </BottomSheetHeader>
      <BottomSheetBody>
        <EmptyState
          description={errorId && `${t("errorId")}: ${errorId}`}
          title={t("somethingWentWrong")}
          variant="no-data"
        />
      </BottomSheetBody>
      <BottomSheetFooter>
        <Button
          className="w-fit"
          onClick={resetErrorBoundary}
          variant="secondary"
        >
          {t("tryAgain")}
        </Button>
      </BottomSheetFooter>
    </>
  )
}
